import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL, BMI_EndPoint } from "./ConstantsHealthCalculator";
import BMITable from "./BMITable";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة مؤشر كتلة الجسم (BMI)";
const DESCRIPTION =
  "هل طولك ملائم لوزنك؟ اكتشف ذلك الان من خلال حاسبة مؤشر كتلة الجسم (BMI) - استخدم حساب مؤشر كتلة الجسم لقياس مستوى اللياقة البدنية وتقييم الوزن الصحي";
const KEYWORDS =
  "مؤشر كتلة الجسم, حساب BMI, حاسبة BMI, كيفية حساب مؤشر كتلة الجسم, صيغة حساب BMI, مؤشرات الصحة وكتلة الجسم, معرفة BMI الخاص بي, BMI الصحي, تحليل BMI والوزن الصحي, كيفية تقييم BMI الخاص بك, قياس كتلة الجسم, حساب مؤشر كتلة الجسم للرجال, حساب مؤشر كتلة الجسم للنساء";
const OG_URL = "https://do-calculate.com/calculator/ar/bmiadults/";
const apiEndpoint = `${SERVER_URL}/${BMI_EndPoint}`;
function BMICalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const calculateBMI = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, height }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                مؤشر كتلة الجسم (BMI) هو مقياس يُستخدم لتحديد الحالة الغذائية
                للبالغين. يتم احتسابه من وزن الشخص بالكيلوغرام، مقسوماً على طوله
                (مربع) بالسنتيمتر. المستويات الموصى بها مستمدة من التوصية
                العالمية لمنظمة الصحة العالمية والتي تشير إلى أن نطاق المؤشر
                الطبيعي للBMI يتراوح بين 18.5 و 24.9.
                <br />
                تقوم هذه الحاسبة بإرجاع مؤشر كتلة الجسم والتنصيف المرتبط بها
                بناءً على المستويات المحددة من قبل منظمة الصحة العالمية. الحاسبة
                تقوم بحساب كتلة الجسم BMI للرجال وللنساء.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  مؤشر كتلة الجسم للبالغين BMI
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="height" className="form-label ms-2">
                      الطول
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text ">سم</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      الوزن
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text ">كغ</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBMI}
                  >

                    إحسب

                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <BMITable classification={classification}></BMITable>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="row">
                <div className="col">
                  {statusCode === 400 && (
                    <div className="alert alert-warning">
                      <b>
                        <u> حدث خطأ :</u>
                      </b>{" "}
                      يُرجى إدخال طول و وزن صحيحين{" "}
                    </div>
                  )}
                  {result && (
                    <div>
                      <h4>النتائج:</h4>
                      <hr />
                      <div
                        className=" alert alert-success"
                      >
                        {" "}
                        <label>
                          <b> مؤشر كتلة الجسم (BMI) : </b>
                          {result.BMI.toFixed(1)} <label> كغ/م2</label>
                        </label>
                      </div>
                      <div
                        className=" alert alert-success"
                      >
                        {" "}
                        <label>
                          <b> التصنيف: </b> {result.classification}
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>
                  حساب مؤشر كتلة الجسم BMI (بالغين) - قياس صحة جسمك بسهولة
                </h2>
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب مؤشر كتلة الجسم BMI (بالغين) - قياس صحة جسمك بسهولة
                  </h2>{" "}
                </u>
                <br />
                <p>
                  مؤشر كتلة الجسم (BMI)، والذي كان يُعرف سابقًا بمؤشر كوتليه، هو
                  مقياس يُستخدم لتحديد الحالة الغذائية للبالغين. يتم تعريفه على
                  أنه وزن الشخص بالكيلوجرام مقسومًا على مربع طول الشخص بالأمتار
                  (كغ/م2). على سبيل المثال، إذا كان وزن البالغ هو 70 كجم وطوله
                  1.75 متر، فسيكون لديه مؤشر كتلة الجسم مقداره 22.9. 70 (كجم) /
                  1.752 (م2) = 22.9 BMI بالنسبة للبالغين فوق سن 20 عامًا، يندرج
                  قياس كتلة الجسم في إحدى التي تم ذكرها في الجدول السابق.
                </p>
                <p>
                  تعتمد فئات مؤشر كتلة الجسم (BMI) على تأثير الدهون الزائدة في
                  الجسم على الأمراض والوفاة، وهي ترتبط بشكل جيد بالتدبير الدهني.
                  تم تطوير مؤشر كتلة الجسم كمؤشر لمخاطر الإصابة بالأمراض؛ حيث
                  تزداد المخاطر مع زيادة مؤشر كتلة الجسم. بعض الحالات الشائعة
                  المرتبطة بالوزن الزائد والسمنة تشمل: الوفاة المبكرة، الأمراض
                  القلبية والوعائية، ارتفاع ضغط الدم، تهتك المفاصل، بعض أنواع
                  السرطان، وداء السكري.
                </p>
                <p>
                  يُوصَى أيضًا باستخدام مؤشر كتلة الجسم في الأطفال والمراهقين.
                  في حالة الأطفال، يتم حساب مؤشر كتلة الجسم بنفس الطريقة
                  المستخدمة للبالغين، ثم يتم مقارنته مع قيم z أو النسب المئوية.
                  خلال مرحلة الطفولة والمراهقة، تختلف النسبة بين الوزن والطول
                  حسب الجنس والعمر، لذا فإن القيم الحدية التي تحدد الحالة
                  الغذائية للأفراد الذين تتراوح أعمارهم بين 0 و 19 عامًا تعتمد
                  على الجنس والعمر. تم تحديد النقاط الحدية لمؤشر كتلة الجسم
                  بالنسبة للعمر لعام 2006 للأطفال الذين تتراوح أعمارهم بين 0 و 5
                  سنوات لتشخيص الوزن الزائد والسمنة كالنسبة 97 والنسبة 99 على
                  التوالي. بالنسبة للأشخاص الذين تتراوح أعمارهم بين 5 و 19
                  عامًا، يتم تعريف الوزن الزائد بأنه قيمة مؤشر كتلة الجسم للعمر
                  تزيد عن +1
                </p>
                <hr />
                <u>
                  <b>تاريخ:</b>
                </u>{" "}
                <br />
                مؤشر كتلة الجسم (BMI) سهل جدًا في القياس والحساب، وبالتالي فإنه
                هو الأداة الأكثر استخدامًا لربط مخاطر مشاكل الصحة بالوزن على
                مستوى السكان. تم تطويره من قبل أدولف كيتليت خلال القرن التاسع
                عشر. خلال السبعينيات وبناءً على بيانات وتقرير دراسة الدول السبع،
                لاحظ الباحثون أن مؤشر كتلة الجسم يبدو أنه مؤشر جيد للتدبير
                الدهني ومشاكل الوزن الزائد.
                <br />                مثل أي قياس آخر، فإنه ليس مثاليًا لأنه يعتمد فقط على الطول
                والوزن ولا يأخذ في الاعتبار مستويات مختلفة من التدبير الدهني
                بناءً على العمر ومستويات النشاط البدني والجنس. لهذا السبب، من
                المتوقع أنه يبالغ في قياس التدبير الدهني في بعض الحالات ويقلل
                منه في حالات أخرى.
                <br />                تتعدد القياسات الأخرى مثل محيط الخصر (WC) ويمكن أن تكمل تقديرات
                مؤشر كتلة الجسم (BMI). إلا أن ربط محيط الخصر بمخاطر الصحة ليس
                أمرًا سهلاً ويجب أن يتم بطريقة علمية باستخدام تقنيات مناسبة.
                <br />                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    فوائد النشاط البدني المنتظم{" "}
                  </h2>{" "}
                </u>
                <p>
                  النشاط البدني المنتظم - مثل المشي، وركوب الدراجة، والرقص - له
                  فوائد كبيرة للصحة. على سبيل المثال، يمكن أن يقلل من خطر
                  الإصابة بأمراض القلب والشرايين وداء السكري وهشاشة العظام،
                  ويساعد في التحكم في الوزن وتعزيز الرفاهية العقلية.
                </p>
                <p></p>
                <p>
                  المشاركة في النشاط البدني يزيد من فرص التواصل الاجتماعي
                  والتواصل وتعزيز الهوية الثقافية. النشاط البدني له تأثير إيجابي
                  على المجتمع والمجتمع عن طريق تعزيز التفاعل الاجتماعي والتلاحم.
                </p>
                <p>
                  خاصة بين الأطفال والشباب، يساهم الرياضة والأنشطة البدنية
                  الأخرى في تمكين الذات وزيادة الثقة بالنفس. بالإضافة إلى ذلك،
                  يساعد النشاط البدني في منع والتحكم في السلوكيات الخطرة، مثل
                  تعاطي التبغ والكحول وغيرها من المواد الضارة، وتناول الطعام غير
                  الصحي والعنف.
                </p>
                <p>
                  تروج للنشاط البدني لها أيضًا تأثير إيجابي على البيئة. على سبيل
                  المثال، تشجيع المشي وركوب الدراجات بدلاً من استخدام وسائل
                  النقل المحركة يقلل من ازدحام المرور وتلوث الهواء والضوضاء
                  واستهلاك الوقود الأحفوري.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    فوائد النظام الغذائي المتوازن{" "}
                  </h2>{" "}
                </u>
                <ul>
                  <li>
                    الاختيار القائم على نظام غذائي متوازن ومتنوع هو خطوة مهمة
                    نحو نمط حياة سعيد وصحي.
                  </li>
                  <li>
                    الفيتامينات والمعادن في النظام الغذائي ضرورية لتعزيز المناعة
                    والنمو الصحي.
                  </li>
                  <li>
                    يمكن أن يحمي النظام الغذائي الصحي الجسم البشري من بعض أنواع
                    الأمراض، خاصة الأمراض غير السارية مثل السمنة والسكري وأمراض
                    القلب وبعض أنواع السرطان وحالات الهيكل العظمي.
                  </li>
                  <li>
                    يمكن أن يساهم النظام الغذائي الصحي أيضًا في الحفاظ على وزن
                    الجسم المناسب.
                  </li>
                  <li>
                    التغذية الصحية هي فرصة جيدة لإثراء الحياة من خلال تجربة
                    أطعمة مختلفة من ثقافات ومصادر مختلفة وبطرق مختلفة لإعداد
                    الطعام.
                  </li>
                  <li>
                    فوائد تناول مجموعة متنوعة من الأطعمة تشمل أيضًا الجانب
                    العاطفي، حيث تعتبر التنوع واللون عناصر مهمة في النظام
                    الغذائي المتوازن.
                  </li>
                </ul>
                <br />                <b>المصدر: </b>
                <a href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations">
                  منظمة الصحة العالمية
                </a>{" "}
                <br />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هو مؤشر كتلة الجسم (BMI)؟
                </h3>
              </div>
              <div className="info-section-body">
                مؤشر كتلة الجسم (BMI) هو أحد الطرق الشائعة لتحديد ما إذا كان
                وزنك صحيًا أم لا. يتم استخدامه لقياس نسبة الدهون في الجسم بناءً
                على الوزن والطول للبالغين.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يتم حساب مؤشر كتلة الجسم (BMI)؟
                </h3>
              </div>
              <div className="info-section-body">
                يتم حساب مؤشر كتلة الجسم (BMI) عن طريق قسمة وزن الشخص
                (بالكيلوجرام) على مربع طوله (بالأمتار). يمكن استخدام الوحدات
                الأمريكية (الباوند والإنش) أيضًا عند تعويض الوحدات القياسية.
                بمجرد الحصول على هذا الرقم، قم بضربه في 703 للحصول على نسبة BMI
                النهائية.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h1 style={{ fontSize: "16px" }}>
                  ما هي فئات مؤشر كتلة الجسم (BMI)؟
                </h1>
              </div>
              <div className="info-section-body">
                بمجرد حساب مؤشر كتلة الجسم (BMI)، ستجد نفسك في إحدى الفئات
                التالية:
                <ul>
                  <li>أقل من 18.5: نطاق الوزن الأقل من الطبيعي</li>
                  <li>من 18.5 إلى 24.9: نطاق الوزن الصحي</li>
                  <li>من 25.0 إلى 29.9: نطاق زيادة الوزن</li>
                  <li>30.0 وأكثر: نطاق السمنة</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكن لمؤشر كتلة الجسم (BMI) أن يخبرني كم يجب علي تخسيسه من
                  وزني؟
                </h3>
              </div>
              <div className="info-section-body">
                المؤشر نفسه لن يقدم لك هدفًا لتخسيس الوزن والحفاظ عليه، ولكن
                يمكنك استخدام جداول مؤشر كتلة الجسم المتوفرة على موقع المعهد
                الوطني للصحة (NIH) لحساب كم يجب عليك تخسيسه لتحقيق نطاق BMI
                الصحي/طبيعي.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هو معدل مؤشر كتلة الجسم (BMI){" "}
                </h3>
              </div>
              <div className="info-section-body">
                وفقًا لتقرير الإحصاءات الوطنية للصحة الوطنية لعام 2018 من مراكز
                مكافحة الأمراض والوقاية منها (CDC)، يبلغ متوسط مؤشر كتلة الجسم
                (BMI) للنساء الأمريكيات فوق سن العشرين 29.6، و29.1 للرجال
                الأمريكان في نفس الفئة العمرية.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يختلف مؤشر كتلة الجسم (BMI) بين الرجال والنساء؟
                </h3>
              </div>
              <div className="info-section-body">
                على الرغم من أن تقارير مراكز مكافحة الأمراض والوقاية منها (CDC)
                تقسم السكان حسب الجنس، إلا أن مؤشر كتلة الجسم (BMI) لا يميز بين
                الرجال والنساء. يستخدم نفس الطريقة في حسابه ونفس الفئات بغض
                النظر عن الجنس.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  مدى دقة مؤشر كتلة الجسم (BMI)؟
                </h3>
              </div>
              <div className="info-section-body">
                على الرغم من أن مؤشر كتلة الجسم (BMI) هو مؤشر موثوق لظروف الوزن،
                إلا أنه ليس مثاليًا. المؤشر مصمم لقياس نسبة الدهون في الجسم ولا
                يأخذ عوامل مثل كتلة العضلات أو كثافة العظام في الاعتبار.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل معرفة مؤشر كتلة الجسم (BMI) مهمة لفقدان الوزن؟
                </h3>
              </div>
              <div className="info-section-body">
                إنها معرفة مفيدة لديك، ولكنها ليست القطعة الوحيدة المهمة من
                المعلومات المتاحة لك عندما يتعلق الأمر بفقدان الوزن. كما تم
                مناقشته سابقًا، يقوم مؤشر كتلة الجسم (BMI) فقط بتقدير نسبة
                الدهون في الجسم ولا يأخذ في اعتباره كتلة العضلات أو وزن الماء أو
                كثافة العظام. التحديد الدقيق لنسب هذه المكونات أمر أساسي لبناء
                برنامج ناجح لفقدان الوزن.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يختلف مؤشر كتلة الجسم (BMI) بين الرجال والنساء؟
                </h3>
              </div>
              <div className="info-section-body">
                على الرغم من أن تقارير مراكز مكافحة الأمراض والوقاية منها (CDC)
                تقسم السكان حسب الجنس، إلا أن مؤشر كتلة الجسم (BMI) لا يميز بين
                الرجال والنساء. يستخدم نفس الطريقة في حسابه ونفس الفئات بغض
                النظر عن الجنس.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BMICalculator;
